/**
 * Placeholder changelog content, so the What's New page and the sign-in popup
 * can be reviewed before the API exists.
 *
 * DELETE THIS FILE once /whats-new is wired to the backend. The shape below is
 * what the page expects back:
 *
 *   {
 *     version: string,        // rendered in the monospace tag, e.g. "v2.4.0"
 *     date:    string,        // ISO date; formatted for display by formatReleaseDate
 *     changes: [{ type, text }]
 *   }
 *
 * `type` is one of the keys in CHANGE_TYPES:
 *   'feature' | 'improvement' | 'fix' | 'performance' | 'deprecated'
 *
 * Releases are listed newest first — the page does not sort, it renders the
 * order it is given.
 */
export const PLACEHOLDER_RELEASES = [
  {
    version: 'v2.4.0',
    date: '2026-09-09',
    changes: [
      { type: 'feature', text: "Send outbound email from your own organisation's domain instead of the default Xtract address, with DNS records generated for you." },
      { type: 'feature', text: "Read release notes in the app under Help > What's New, newest release first." },
      { type: 'feature', text: 'Per-template sending domain selection, so different business units can send under different addresses.' },
      { type: 'improvement', text: 'The Business Central metadata catalogue now waits for the full response window, so large environments finish loading instead of timing out.' },
      { type: 'fix', text: 'Reviewers no longer see approval actions on requests that sit outside the templates they are assigned to.' },
    ],
  },
  {
    version: 'v2.3.1',
    date: '2026-08-22',
    changes: [
      { type: 'feature', text: 'Two-step NetSuite template setup — pick the company, fetch its fields, then map them.' },
      { type: 'improvement', text: 'Business Central lookups and field rules refresh on their own and are validated locally before a template is saved.' },
      { type: 'fix', text: 'The mapping dropdown no longer fails silently for template managers.' },
      { type: 'fix', text: 'An empty field catalogue now says why it came back empty instead of showing a blank list.' },
    ],
  },
  {
    version: 'v2.3.0',
    date: '2026-08-05',
    changes: [
      { type: 'feature', text: 'Review NetSuite field mappings before a request is posted.' },
      { type: 'feature', text: 'CSV export to an FTP or SFTP destination through the new output connector framework.' },
      { type: 'feature', text: 'See the AI cost breakdown for an individual request.' },
      { type: 'improvement', text: 'Export Status refreshes itself after publish, and pending deliveries are polled until they land.' },
      { type: 'improvement', text: 'Field mapping and filename patterns are quicker to set up on output destinations.' },
      { type: 'fix', text: 'Empty values in CSV exports and "Unknown destination" labels are resolved.' },
    ],
  },
]
